<!-- =========================================================================================
  File Name: createDeposit.vue
  Description: Create Deposit component
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 24062020
========================================================================================== -->
<template>
  <div id="Aggrement" ref="Aggrement">
    <div class="vx-row">
      <div v-if="this.getSelectedData" class="vx-col w-1/1 md:w-1/2">
        <div
          :v-on="this.selectedItem != -1"
          class="rounded-lg border d-theme-border-grey-light mb-6"
          style="font-size: 11px"
        >
          <div class="flex items-start" :v-on="this.selectedItem != -1">
            <img style="max-width: 150px" :src="GetProviderImg(this.getSelectedData == null ? '' : this.getSelectedData.icon)" :alt="this.getSelectedData == null ? '' : this.getSelectedData.name" />
            <div class="mx-2"></div>
          </div>
        </div>
        <div class="rounded-lg border border-solid d-theme-border-grey-light m-0 p-2 mb-4 w-full ml-auto" style="height: 400px">
          <component :is="scrollbarTag" class="scroll-area--nofications-dropdown pl-4 pr-4" :settings="settings" :key="$vs.rtl">
            <div class="pt-2" v-if="
                `${getDepositDescriptions}` == 'WebMoney' ||
                `${getDepositDescriptions}` == 'BankWire' ||
                `${getDepositDescriptions}` == 'CreditDebitCard' ||
                `${getDepositDescriptions}` == 'CreditCard'" >
              <vs-collapse open-hover>
                <vs-collapse-item>
                  <div slot="header">
                    <h4>{{ $t("ExtraInfo") }}</h4>
                  </div>
                  <div v-for="item in this.$t(`depositDescriptions.${getDepositDescriptions}`)" :key="item.id" class="mt-4">
                    <h4 v-if="item.isBold">{{ item.text }}</h4>
                    <p v-if="!item.isBold">{{ item.text }}</p>
                  </div>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <div class="mt-6" style="color: black">
              <vs-collapse open-hover>
                <vs-collapse-item>
                  <div slot="header">
                    <h4>{{ $t("WithdrawalInfoHeader2") }}</h4>
                  </div>
                  <p>{{ $t("WithdrawalInfoText2") }}</p>
                  <br />
                  <p>{{ $t("WithdrawalInfoText3") }}</p>
                </vs-collapse-item>
              </vs-collapse>
            </div>

            <!-- <vs-checkbox class="inline-flex mb-4 mt-4 ml-8 text-danger" v-model="requestDeposit.IAccept">I Accept</vs-checkbox> -->
          </component>
        </div>
      </div>
      <div class="vx-col w-1/1 md:w-1/2 w-full">
        <vs-input
          :label="$t('Amount')"
          class="w-full mb-4"
          @keypress="onlyForCurrency"
          @click="SelectAmount()"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
          v-model="requestDeposit.payerAmount"
          ref="AmountAmount"
        />
        <!-- <vs-input label="Account" type="email" class="w-full mb-4" icon-pack="feather" icon="icon-credit-card" icon-no-border v-model="requestDeposit.account" /> -->
        <div class="mb-4">
          <label class="vs-input--label">{{ $t("Account") }}</label>
          <v-select
            v-model="requestDeposit.account"
            :reduce="(item) => item.value"
            :clearable="false"
            :options="getAccounts"
            v-validate="'required'"
            name="status"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-danger text-sm" v-show="errors.has('status')">{{
            errors.first("status")
          }}</span>
        </div>
        <!-- <vs-input label="Email" v-if="this.selectedItem == 0" class="w-full mb-4" icon-pack="feather" icon="icon-mail" icon-no-border  v-model="requestDeposit.email" /> -->
        <vs-textarea
          label="Description"
          v-if="this.selectedItem == 0"
          class="w-full mb-4"
          v-model="requestDeposit.comment"
        />
        <!-- <vs-checkbox class="w-full mb-4" v-model="requestDeposit.wantBonus">Get bonus on deposit for this account. (The leverage cannot exceed 1:500)</vs-checkbox> -->

        <form
          name="perfectmoney"
          action="https://perfectmoney.is/api/step1.asp"
        >
          <input type="hidden" name="PAYEE_ACCOUNT" value="U14839188" />
          <input type="hidden" name="PAYEE_NAME" value="Number One Capital Markets Ltd." />
          <input type="hidden" name="PAYMENT_ID" v-model="responsePerfectMoney.transactionid"  value="" />
          <input type="hidden" name="PAYMENT_AMOUNT" v-model="responsePerfectMoney.amount" value=""/>
          <input type="hidden" name="PAYMENT_UNITS" v-model="responsePerfectMoney.currency" value=""/>
          <input type="hidden" name="STATUS_URL" v-model="responsePerfectMoney.statusurl" value=""/>
          <input type="hidden" name="PAYMENT_URL" v-model="responsePerfectMoney.paymenturl" value="" />
          <input type="hidden" name="PAYMENT_URL_METHOD" value="POST" />
          <input type="hidden" name="NOPAYMENT_URL" v-model="responsePerfectMoney.nopaymenturl" value="" />
          <input type="hidden" name="NOPAYMENT_URL_METHOD" value="POST" />
          <input type="hidden" name="mt4account" v-model="responsePerfectMoney.account" value="" />
          <input type="hidden" name="transactionid" v-model="responsePerfectMoney.transactionid" value="" />
          <input type="hidden" name="puid" v-model="responsePerfectMoney.puid" value=""/>
          <input type="hidden" name="BAGGAGE_FIELDS" value="mt4account transactionid puid"/>
          <input type="submit" style="display: none" value="submit" />
        </form>

        <!-- <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button class="mr-3 mb-2">Submit</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="ResetFormData()">Reset</vs-button>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import moduleMt4Management from '@/store/mt4-management/moduleMt4Management.js'
import vSelect from 'vue-select'
import Mgr from '@/services/SecurityService'
const user = new Mgr()

export default {
  props: {
    selectedItem: {
      type: Number,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {
      userInfo: null,
      user: null,
      status: null,
      user_accounts: null,
      payload: { email: null, server: 'Real' },
      user_data: {},
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      responsePerfectMoney: {
        transactionid: 0,
        amount: 0,
        statusurl: '',
        paymenturl: '',
        nopaymenturl: '',
        account: '',
        puid: '',
        currency: ''
      },
      requestDeposit: {
        account: 0,
        amount: 0,
        currency: 1,
        status: 0,
        comment: '',
        note: '',
        product: 0,
        fee: 0,
        rate: 0,
        externalId: '',
        externalStatus: 0,
        ticket: 0,
        payerAmount: 0,
        payerCurrency: 1,
        payerFee: 0,
        providerId: 0,
        providerMethodId: 0,
        walletDetail: '',
        data: {}
        // wantBonus: false
      }
    }
  },
  computed: {
    getDepositDescriptions () {
      if (this.getSelectedData.name === 'Webmoney') return 'WebMoney'
      else if (this.getSelectedData.name === 'BankWire') return 'BankWire'
      else if (this.getSelectedData.name === 'CreditDebitCard') return 'CreditDebitCard'
      else if (
        this.getSelectedData.name === 'CC_IYZ' ||
        this.getSelectedData.name === 'CC_iPay'
      ) return 'CreditCard'
      else return this.getSelectedData.name
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    getSelectedData () {
      return this.data.find((item) => {
        return item.id === this.selectedItem
      })
    },
    getAccounts () {
      if (!this.user_accounts) return []
      return this.user_accounts.map((d) => ({
        label: `${d.Login} - (L:${d.Leverage}) MF:(${d.Margin_Free})`,
        value: d.Login
      }))
    }
  },
  methods: {
    GetProviderImg (ProviderImgName) {
      if (ProviderImgName === '') return ''
      return require(`@/assets/images/providers/${ProviderImgName}`)
    },
    onlyForCurrency ($event) {
      this.requestDeposit.payerAmount = `${this.requestDeposit.payerAmount}`
      const keyCode = $event.keyCode ? $event.keyCode : $event.which
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || this.requestDeposit.payerAmount.indexOf('.') !== -1)
      ) {
        // 46 is dot
        $event.preventDefault()
      }
      if (
        this.requestDeposit.payerAmount &&
        this.requestDeposit.payerAmount.indexOf('.') > -1 &&
        this.requestDeposit.payerAmount.split('.')[1].length > 1
      ) {
        $event.preventDefault()
      }
    },

    ResetFormData () {
      this.requestDeposit.payerAmount = 0
      // this.requestDeposit.wantBonus = false
      this.requestDeposit.account = this.requestDeposit.comment = ''
    },
    SelectAmount () {
      this.$refs.AmountAmount.$refs.vsinput.select()
    },
    Process () {
      return new Promise((resolve, reject) => {
        this.requestDeposit.providerMethodId = this.selectedItem
        // this.requestDeposit.wantBonus = this.requestDeposit.wantBonus === false ? 0 : 1
        this.requestDeposit.amount = this.requestDeposit.payerAmount
console.error(this.requestDeposit.providerMethodId)
        this.$store
          .dispatch('TransactionMng/addDeposit', this.requestDeposit)
          .then((res) => {
            if (this.requestDeposit.providerMethodId !== 6000) {
              console.log(res)
              resolve(res)
            } else {
              this.responsePerfectMoney.transactionid =
                res['data']['data']['transactionid']
              this.responsePerfectMoney.amount = res['data']['data']['PAYMENT_AMOUNT']
              this.responsePerfectMoney.statusurl = res['data']['data']['STATUS_URL']
              this.responsePerfectMoney.paymenturl = res['data']['data']['PAYMENT_URL']
              this.responsePerfectMoney.nopaymenturl =
                res['data']['data']['NOPAYMENT_URL']
              this.responsePerfectMoney.account =
                res['data']['data']['mt4account']
              this.responsePerfectMoney.puid = res['data']['data']['puid']
              this.responsePerfectMoney.currency =
                res['data']['data']['PAYMENT_UNITS']
              document.perfectmoney.submit()
            }
          })
          .catch((err) => {
            reject(`correct all values. ${err}`)
          })
      })
    },
    getUserAccounts () {
      user.getUser().then((u) => {
        this.user = u
      })
      user.getProfile().then((response) => {
        this.userInfo = response
        if (this.userInfo) {
          this.payload.email = this.$store.state.AppActiveUser.email
          //this.payload.email = this.userInfo.email
          this.payload.server = 'Real'
          this.$store
            .dispatch('TransactionMng/fetchUserAccountsByEmail', this.payload)
            .then((res) => {
              // console.error(res.data.data)
              this.user_accounts = res.data.data
            })
            .catch((err) => {
              console.error(err)
            })
        }
      })
    }
  },

  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    if (!moduleMt4Management.isRegistered) {
      this.$store.registerModule('Mt4Management', moduleMt4Management)
      moduleMt4Management.isRegistered = true
    }

    this.getUserAccounts()
  }
}
</script>
